import {createAction, props} from '@ngrx/store';
import {StreamStatus} from '../../services/api/stream-statuses/stream-status.model';

const prefix = '[Stream Statuses]';

export const loadStreamStatuses = createAction(
  `${prefix} Load All Stream Statuses`
);

export const loadStreamStatusesSuccess = createAction(
  `${prefix} Load All Stream Statuses Success`,
  props<{ data: StreamStatus[] }>()
);

export const loadStreamStatusesFailure = createAction(
  `${prefix} Load All Stream Statuses Failure`,
  props<{ error: unknown }>()
);

export const updateStreamStatuses = createAction(
  `${prefix} Update Stream Statuses`,
  props<{ data: StreamStatus[] }>()
);

export const clearStreamStatusesState = createAction(
  `${prefix} Clear Stream Statuses State`
);
